import React, { Component } from 'react'
import { toastContainer } from '../../utils/toast'
import { isMobile } from '../../utils/deviceInfo'
import './trivia-survey.css'
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Badge,
} from 'reactstrap'
import { connect } from 'react-redux'
import moment from 'moment'
import { GiBigGear, GiOpenTreasureChest } from 'react-icons/gi'
import { LuCalendarCheck } from 'react-icons/lu'
import { CSVLink } from 'react-csv'
import axios from '../../axios'
import * as url from '../../utils/url'
import * as actionCreators from '../../modules/actions/index'
import Loading from '../../hoc/Loading/Loading'
import { AiFillCloseCircle } from 'react-icons/ai'
import { MdFileUpload } from 'react-icons/md'
import { FaArrowRight } from 'react-icons/fa6'
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutHeadingLines,
  LayoutDataLines,
  LayoutRowLines,
  LayoutRow,
} from '../../components/TableComponents/RowCardShadow/RowCardShadow'

import {
  formatDuration,
  getTrivvyRating,
  isTrivvyGeneratedFromCustomTemplates,
  SURVEY_LIST,
  WEB_GENERATE_ERROR_MESSAGE,
} from './data'
import ReactTooltip from 'react-tooltip'
import If from '../../components/Shared/If'
import { SURVEY_QUESTIONS } from '../../components/Survey/data'
import {
  BiDotsHorizontal,
  BiDownArrowAlt,
  BiEditAlt,
  BiNotepad,
  BiUpArrowAlt,
  BiX,
} from 'react-icons/bi'
import { BsDownload, BsGearFill, BsThreeDots } from 'react-icons/bs'
import RenamePopup from './Components/RenamePopup'
import DeleteTriviaPopup from './Components/DeleteTriviaPopup'
import { orderBy } from 'lodash'
import CreateSurveyPopup from './Components/CreateTrivia/CreateTriviaPopup'
import RewardCreateModal from './Components/RewardCreateModal'

import EmptyTable from '../../components/EmptyTable/EmptyTable'
import { baseUrl, Spinner, triviaListCategories } from '../../utils/constants'
import BottomScrollListener from 'react-bottom-scroll-listener'
import UploadUsersModal from './Components/UploadUsersModal'
import ResponsePurchaseModal from './Components/ResponsePurchaseModal'
import TrivvyResponseCounter from './Components/TrivvyResponseCounter'
import ApplyPurchaseToTrivvy from './Components/ApplyPurchaseToTrivvyModal'
import DuplicateTriviaPopup from './Components/DuplicateTriviaPopup'
import TrivvyImmediateRewardToast from '../../components/TrivvyToast/TrivvyImmediateRewardToast'
import CreateTriviaModalMain from './Components/CreateTrivia/CreateTriviaModalMain'
import TrivvyLinkedRewardsDetailsModal from './Components/TrivvyLinkedRewardsDetailsModal'
import CheckBox from 'rc-checkbox'
import WarningModal from '../../components/Trivvy/WarningModal'
import ManualRemindersModal from './Components/ManualRemindersModal'
import { TiChartLine } from 'react-icons/ti'
import SurveySamplesPage from './SurveySamplesPage'
import TriviaRewards from './TriviaRewards'
import LocalSearchBar from './Components/LocalSearchBar'

class TriviaKCSList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rewardDescModalId: null,
      firstTimePopupText: '',
      uploadFileOpen: false,
      newGeneratedSurvey: [],
      surveyList: [],
      hoveredSurvey: null,
      optionsPopoverOpen: null,
      invidualItemAction: {
        type: null,
        item: null,
      },
      loadingCreateTrivia: false,
      currentPage: 1,
      uploadUsersModal: false,
      purchaseResponsesModal: false,
      responsePurchaseCallbackData: null,
      applyPurchaseModalData: null,
      applyPurchaseOpen: false,
      selectedTrivvys: [],
      selectedTrivvysWarningModal: {
        open: false,
        message: null,
      },
      surveySamplesModalOpen: false,
      rewardsModalOpen: false,
      // Local search state (mirrors TriviaLibraryListPage pattern).
      // When isSearchActive is true, the rendered list comes from searchResults
      // instead of surveyList. Pagination uses searchCurrentPage/searchHasMore
      // driven by the BottomScrollListener.
      searchQuery: '',
      searchResults: null,
      isSearchActive: false,
      searchCurrentPage: 1,
      searchHasMore: true,
      searchLoading: false,
    }
  }
  // 6539c18cc96ae27405744df6
  componentDidMount() {
    const { organizationId } = this.props.user.profile

    if (this.props.showCreatePopup) {
      this.setState({
        uploadFileOpen: true,
        firstTimePopupText:
          this.props.user && this.props.user.profile
            ? `Welcome, ${this.props.user.profile.firstName} ${this.props.user.profile.lastName}. Let's create your first Trivvy. To start select one of the options below.`
            : '',
      })
    } else {
    }

    if (isMobile) {
      this.props.updateNavBar({
        title: 'Knowledge Checks',
        hasBack: true,
        backButton: '<b>Back</b>',
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      })
    } else {
    }

    let that = this

    //axios.get(url.findOrgById(organizationId._id)).then(({ data }) => {
    //  const payload = data.data;
    //  that.props.orgChangeSuccess(payload);
    //});

    if (!this.props.showTrivvyListOnly) {
      this.retrieveSurveys(1)
    }

    this.props.setCurrentTrivia(null)

    // const queyParams = new URLSearchParams(window.location.search);

    // const stripe_session_id = queyParams.get("session_id");
    // const response_purchase_id = queyParams.get("responsePurchaseId");

    // if (stripe_session_id && response_purchase_id) {
    //   axios
    //     .get(url.getStripeSessionStatus(stripe_session_id))
    //     .then(({ data }) => {
    //       const result = data.data;

    //       if (result.status == "complete") {
    //         axios
    //           .get(url.handlePurchaseSuccess(response_purchase_id))
    //           .then(({ data }) => {
    //             const result = data.data;

    //             this.props.orgChangeSuccess(result.org);

    //             this.setState({
    //               purchaseResponsesModal: true,
    //               responsePurchaseCallbackData: {
    //                 success: true,
    //                 ...result.purchase,
    //               },
    //             });
    //           })
    //           .catch((err) => {
    //             toastContainer(
    //               "Error while increasing response limit",
    //               "error"
    //             );
    //             this.setState({
    //               purchaseResponsesModal: true,
    //               responsePurchaseCallbackData: {
    //                 success: false,
    //                 message:
    //                   "Your payment was succesfull but error occured while adding the purchsed responses limit for your organization.",
    //               },
    //             });
    //             console.log(err);
    //           });
    //       } else if (result.status == "open") {
    //         axios
    //           .get(url.handlePurchaseFailure(response_purchase_id))
    //           .then(({ data }) => {
    //             this.setState({
    //               purchaseResponsesModal: true,
    //               responsePurchaseCallbackData: {
    //                 success: false,
    //                 message: "Your payment has been failed, Please try again",
    //               },
    //             });
    //           })
    //           .catch((err) => {
    //             toastContainer("Failed payment", "error");
    //             console.log(err);
    //           });
    //       }
    //     })
    //     .catch((err) => {
    //       toastContainer("Error getting payment session", "error");
    //       console.log(err);
    //     });
    // }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.trivvyOpen != nextProps.trivvyOpen && nextProps.trivvyOpen) {
      this.setState({
        uploadFileOpen: true,
      })
    } else {
    }
    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      this.handleSortChange(
        nextProps.sortParams.sortBy,
        nextProps.sortParams.sortOrder
      )
    }

    if (this.props.showTrivvyListOnly && this.props.trivvyListPrefetchedArray) {
      if (
        JSON.stringify(this.props.trivvyListPrefetchedArray) !==
        JSON.stringify(nextProps.trivvyListPrefetchedArray) &&
        nextProps.trivvyListPrefetchedArray &&
        nextProps.trivvyListPrefetchedArray.length
      ) {
        this.setState(
          { surveyList: nextProps.trivvyListPrefetchedArray },
          () => {
            this.props.updateSortParams({
              sortOrder: 'desc',
              sortBy: 'createdDate',
            })
          }
        )
      }
    }

    if (
      JSON.stringify(this.props.importTemplateAddedTrivvys) !==
      JSON.stringify(nextProps.importTemplateAddedTrivvys)
    ) {
      if (nextProps.importTemplateAddedTrivvys.length > 0) {
        this.setState({
          surveyList: [
            ...nextProps.importTemplateAddedTrivvys,
            ...this.state.surveyList,
          ],
        })
        this.props.setImportTemplateAddedTrivvys([])
      }
    }

    if (
      JSON.stringify(this.props.updateTrivvyLinkedRewards) !==
      JSON.stringify(nextProps.updateTrivvyLinkedRewards)
    ) {
      const updateDoc = nextProps.updateTrivvyLinkedRewards
      console.log('check 1 ---', updateDoc)
      const trivvysOld = [...this.state.surveyList]

      if (
        updateDoc.rewardId &&
        updateDoc.trivvyIds &&
        updateDoc.trivvyIds.length
      ) {
        for (const id of updateDoc.trivvyIds) {
          const triviaIndex = trivvysOld.findIndex((x) => x._id == id)

          console.log('check 2 ---', triviaIndex)

          if (triviaIndex >= 0) {
            let newDoc = { ...trivvysOld[triviaIndex] }

            newDoc.linkedRewards = [
              ...newDoc.linkedRewards,
              { itemId: updateDoc.rewardId },
            ]
            trivvysOld[triviaIndex] = newDoc

            console.log('check 3 ---', trivvysOld[triviaIndex])

            this.setState({
              surveyList: [...trivvysOld],
            })
          }
        }
      }
    }
  }

  handleTrivvyRowCheckboxClick = (value, id) => {
    const trivvys = [...this.state.selectedTrivvys]

    if (trivvys.includes(id)) {
      const newTrivvys = trivvys.filter((x) => x != id)
      this.setState({ selectedTrivvys: newTrivvys })
    } else {
      trivvys.push(id)
      this.setState({ selectedTrivvys: trivvys })
    }
  }

  handleSelectAllTrivvys = (value) => {
    const { surveyList } = this.state
    if (value) {
      const allTrivvyIds = surveyList.map((item) => item._id)
      this.setState({ selectedTrivvys: allTrivvyIds })
    } else {
      this.setState({ selectedTrivvys: [] })
    }
  }

  handleBottomScroll = () => {
    // alert("lll")
    if (!this.props.showTrivvyListOnly) {
      this.setState({ currentPage: this.state.currentPage + 1 }, () => {
        this.retrieveSurveys(this.state.currentPage)
      })
    }
  }

  // Start a new search. Resets pagination and fetches page 1.
  handleSearch = (query) => {
    this.setState(
      {
        searchQuery: query,
        searchResults: [],
        isSearchActive: true,
        searchCurrentPage: 1,
        searchHasMore: true,
      },
      () => {
        this.performSearchWithPagination(query, 1)
      }
    )
  }

  // Paginated search API call. Reuses the /get-trivia list endpoint with an
  // optional `search` param — the BE ANDs a name regex onto the same
  // condition the list uses (including KC completion enrichment), so results
  // match the list's shape and filtering. triviaCategoryType="KNOWLEDGE_CHECK"
  // scopes the result set to items visible on the Knowledge Checks tab.
  performSearchWithPagination = (query, page) => {
    const pageLimit = 20
    this.setState({ searchLoading: true })

    const params = {
      search: query,
      triviaCategoryType: 'KNOWLEDGE_CHECK',
      page: page,
      perPage: pageLimit,
    }

    axios
      .get(url.getTriviaList, { params })
      .then(({ data }) => {
        const results = data && data.data && data.data.surveys ? data.data.surveys : []

        this.setState((prevState) => ({
          searchResults:
            page === 1 ? results : [...(prevState.searchResults || []), ...results],
          searchLoading: false,
          // If we got a full page back there may be more, otherwise we're done.
          searchHasMore: results.length === pageLimit,
        }))
      })
      .catch((err) => {
        console.error('Error fetching KC search results:', err)
        this.setState({
          searchLoading: false,
          searchHasMore: false,
        })
      })
  }

  // Paginate the search when the user scrolls to the bottom while search is
  // active. Guards prevent duplicate requests in flight.
  handleSearchScrollBottom = () => {
    const { searchHasMore, searchLoading, searchCurrentPage, searchQuery, isSearchActive } = this.state

    if (isSearchActive && searchHasMore && !searchLoading) {
      const nextPage = searchCurrentPage + 1
      this.setState({ searchCurrentPage: nextPage }, () => {
        this.performSearchWithPagination(searchQuery, nextPage)
      })
    }
  }

  // Return to the full list view.
  handleClearSearch = () => {
    this.setState({
      searchResults: null,
      searchQuery: '',
      isSearchActive: false,
      searchCurrentPage: 1,
      searchHasMore: true,
      searchLoading: false,
    })
  }

  // Source of truth for the rendered list: search results when active, else
  // the full surveyList.
  getFilteredList = () => {
    const { surveyList, searchResults, isSearchActive } = this.state
    if (isSearchActive && searchResults !== null) {
      return searchResults
    }
    return surveyList
  }

  retrieveSurveys = (page) => {
    const { sortParams } = this.props
    axios
      .get(url.getTriviaList, { params: { page, perPage: 20, triviaCategoryType: 'KNOWLEDGE_CHECK' } })
      .then(({ data }) => {
        const surveys = data.data.surveys || []
        if (surveys && surveys.length == 0 && page <= 1) {
          this.setState({ surveySamplesModalOpen: true })
        }
        this.setState(
          {
            surveyList: [...this.state.surveyList, ...surveys],
          },
          () => {
            this.handleSortChange(sortParams.sortBy, sortParams.sortOrder)
          }
        )
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleFileUpload = (e) => {
    this.setState({
      uploadedFile: e.target.files[0],
    })
  }

  isValidURL = (url) => {
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(:[0-9]+)?(\/[^\s]*)?$/
    return urlPattern.test(url)
  }

  getSurveyName = () => {
    const { fileUrl, uploadedFile } = this.state
    if (uploadedFile) {
      return uploadedFile.name.split('.')[0]
    } else {
      return 'Knowledge Check - ' + moment().format('DD MMM , YYYY')
    }
  }

  handleSortChange = (key, order) => {
    let surveys = [...this.state.surveyList]

    switch (key) {
      case 'name':
        surveys = orderBy(surveys, (itm) => itm['name'].toLowerCase(), [order])
        break

      case 'questionsCount':
        surveys = orderBy(
          surveys,
          (itm) => itm.questions && itm.questions.length,
          [order]
        )
        break
      case 'averageTime':
        surveys = orderBy(surveys, (itm) => itm.averageTime, [order])
        break
      case 'linkedRewards':
        surveys = orderBy(
          surveys,
          (itm) => itm.linkedRewards && itm.linkedRewards.length,
          [order]
        )
        break
      case 'sent':
        surveys = orderBy(
          surveys,
          (itm) =>
            itm.insightsTotalCount && itm.insightsTotalCount > 0
              ? itm.insightsTotalCount
              : itm.otherMediumsShareCount,
          [order]
        )
        break
      case 'submissions':
        surveys = orderBy(
          surveys,
          (itm) =>
            itm.allowAttempts > 0
              ? itm.completedUsersCount || 0
              : itm.totalSubmissions || 0,
          [order]
        )
        break
      case 'responseRate': {
        const withRate = []
        const noRate = []
        surveys.forEach(function (itm) {
          const denominator =
            itm.insightsTotalCount && itm.insightsTotalCount > 0
              ? itm.insightsTotalCount
              : itm.otherMediumsShareCount
          if (!denominator || denominator === 0) {
            noRate.push(itm)
          } else {
            withRate.push(itm)
          }
        })
        const sorted = orderBy(withRate, function (itm) {
          const denominator =
            itm.insightsTotalCount && itm.insightsTotalCount > 0
              ? itm.insightsTotalCount
              : itm.otherMediumsShareCount
          const numerator = itm.allowAttempts > 0
            ? (itm.completedUsersCount || 0)
            : (itm.totalSubmissions || 0)
          return numerator / denominator
        }, [order])
        surveys = sorted.concat(noRate)
        break
      }
      case 'averageScore':
        surveys = orderBy(surveys, (itm) => Math.round(itm.averageScore), [
          order,
        ])
        break
      case 'createdDate':
        surveys = orderBy(surveys, (itm) => itm.createdOn, [order])
        break
      case 'source':
        surveys = orderBy(surveys, (itm) => itm.uploadType, [order])
        break
      case 'status':
        let expired = surveys.filter(
          (itm) =>
            itm.trivvyEndDate &&
            moment(itm.trivvyEndDate).isSameOrBefore(moment(), 'day')
        )
        let rest = surveys.filter(
          (itm) => !moment(itm.trivvyEndDate).isSameOrBefore(moment(), 'day')
        )
        const rest1 = orderBy(rest, (itm) => itm.isPublished, [order])

        if (order === 'asc') {
          surveys = [...rest1, ...expired]
        } else {
          surveys = [...expired, ...rest1]
        }

        break

      default:
        surveys = orderBy(surveys, (itm) => itm[key], [order])
        break
    }
    this.setState({ surveyList: surveys })
  }

  sortComponent = (key) => {
    const { sortParams } = this.props
    // console.log('key --- ', key)
    if (JSON.stringify(sortParams.sortBy) === JSON.stringify(key)) {
      if (sortParams.sortOrder === 'desc') {
        return (
          <BiDownArrowAlt
            size={'13px'}
            onClick={() => this.changeSortField(key, 'asc')}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        )
      } else {
        return (
          <BiUpArrowAlt
            size={'13px'}
            onClick={() => this.changeSortField(key, 'desc')}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        )
      }
    } else {
      return (
        <BiUpArrowAlt
          size={'13px'}
          onClick={() => this.changeSortField(key, 'desc')}
          className="cursor-pointer trivia-list-sort-arrow-pos"
        />
      )
    }
  }

  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    })
  }

  redirectToSurveyPage = (survey) => {
    // this.props.setCurrentTrivia(survey);
    const { organizationId } = this.props.user.profile
    if (!survey.isPublished) {
      // the edit page is hidden on mobile, so unpublished trivvys open the
      // Share page there instead. Desktop keeps going to Edit.
      const unpublishedTarget = isMobile ? "share" : "edit";
      this.props.history.push(
        `/home/trivia/${organizationId._id}/edit/${survey._id}/${unpublishedTarget}`
      )
    } else if (survey.totalSubmissions > 0) {
      this.props.history.push(
        `/home/trivia/${organizationId._id}/edit/${survey._id}/results`
      )
    } else {
      this.props.history.push(
        `/home/trivia/${organizationId._id}/edit/${survey._id}/share`
      )
    }
  }

  openApplyPurchaseModal = (data) => {
    this.setState({ applyPurchaseOpen: true, applyPurchaseModalData: data })
  }
  closeApplyPurchaseModal = (data) => {
    this.setState({ applyPurchaseOpen: false, applyPurchaseModalData: null })
  }

  handleDropdownAction = (actionType, item) => {
    this.setState({ optionsPopoverOpen: null })
    if (actionType === 'REMIND') {
      this.setState({
        invidualItemAction: {
          type: 'REMIND',
          item: item,
        },
      })
    }
    if (actionType === 'OPEN') {
      this.redirectToSurveyPage(item)
    }
    if (actionType === 'END') {
      axios
        .put(url.editTrivia(item._id), {
          updateData: { trivvyEndDate: moment().startOf("day") },
        })
        .then((data) => {
          const updated = {
            ...item,
            trivvyEndDate: moment().startOf("day"),
          }
          this.onUpdateItem(updated)
          toastContainer('Trivvy ended successfully', 'success')
        })
        .catch((err) => {
          console.log(err)
          toastContainer('Error ending Trivvy', 'error')
        })
    }
    if (actionType === 'RENAME') {
      this.setState({
        invidualItemAction: {
          type: 'RENAME',
          item: item,
        },
      })
    }
    if (actionType === 'PURCHASE') {
      this.openApplyPurchaseModal(item)
    }

    if (actionType === 'DUPLICATE') {
      this.setState({
        invidualItemAction: {
          type: 'DUPLICATE',
          item: item,
        },
      })
    }

    if (actionType === 'COPY') {
      navigator.clipboard.writeText(
        `${baseUrl()}home/trivia/${item.organizationId}/quiz/${item._id}/start`
      )
    }
    if (actionType === 'DELETE') {
      this.setState({
        invidualItemAction: {
          type: 'DELETE',
          item: item,
        },
      })
    }

    if (actionType === 'PUBLISH') {
      axios
        .put(url.updateTrivvyPublish(item._id), {
          updateData: { isPublished: !item.isPublished },
        })
        .then((data) => {
          const updated = {
            ...item,
            isPublished: !item.isPublished,
          }

          this.onUpdateItem(updated)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  closeInvidualItemAction = () => {
    this.setState({
      invidualItemAction: {
        type: null,
        item: null,
      },
    })
  }

  renderRowOptions = (item) => {
    const { optionsPopoverOpen } = this.state
    const { isAdmin } = this.props
    if (item && item._id && isAdmin) {
      return (
        <div className="cursor-pointer">
          <span
            id={`surveyListRow_${item._id}`}
            onClick={() => this.setState({ optionsPopoverOpen: item._id })}
            className="cursor-pointer">
            <BsThreeDots />
          </span>

          <Popover
            isOpen={optionsPopoverOpen == item._id}
            target={`surveyListRow_${item._id}`}
            toggle={() => this.setState({ optionsPopoverOpen: null })}
            placement="bottom"
            hideArrow
            className="surveyListRow_Popover">
            <PopoverBody className="">
              {/* the edit page is hidden on mobile, so drop its 3-dots option there. */}
              {!isMobile && (
                <div
                  className={`${item.isPublished && item.totalSubmissions > 0 ? 'disabled-dropdown-item' : 'cursor-pointer'} dropdown-item my-1`}
                  style={{
                      pointerEvents: item.isPublished && item.totalSubmissions > 0 ? 'none' : 'auto',
                  }}
                  onClick={() => {
                    this.handleDropdownAction('OPEN', item)
                  }}>
                  Edit
                </div>
              )}

              <div
                className={`${item.trivvyEndDate ? 'disabled-dropdown-item' : 'cursor-pointer'} dropdown-item my-1`}
                style={{
                    pointerEvents: item.trivvyEndDate ? 'none' : 'auto',
                }}
                onClick={() => {
                  this.handleDropdownAction('END', item)
                }}>
                End
              </div>

              <div
                className={`${item.isPublished && item.totalSubmissions > 0 ? 'disabled-dropdown-item' : 'cursor-pointer'} dropdown-item my-1`}
                onClick={() => {
                  if (!(item.isPublished && item.totalSubmissions > 0)) {
                    this.handleDropdownAction('PUBLISH', item)
                  }
                }}>
                {item.isPublished ? 'Un-Publish' : 'Publish'}
              </div>
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction('RENAME', item)
                }}>
                Rename
              </div>

              {item.isPublished &&
                item.sharedWithUsers &&
                item.sharedWithUsers.length ? (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.handleDropdownAction('REMIND', item)
                  }}>
                  Remind users
                </div>
              ) : (
                ''
              )}

              <div
                className="dropdown-item cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction('DUPLICATE', item)
                }}>
                Duplicate
              </div>
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction('COPY', item)
                }}>
                Copy Link
              </div>

              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction('DELETE', item)
                }}>
                Delete
              </div>

              {item.waitingCount > 0 && (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.handleDropdownAction('PURCHASE', item)
                  }}>
                  Manage Purchase
                </div>
              )}
            </PopoverBody>
          </Popover>
        </div>
      )
    } else {
      return null
    }
  }

  onDeleteItem = (id) => {
    const { surveyList } = this.state
    const docs = [...surveyList]

    const newDocs = docs.filter((x) => x._id != id)

    this.setState({ surveyList: newDocs })

    this.closeInvidualItemAction()

    if (this.props.onDeleteFromLibList) {
      this.props.onDeleteFromLibList()
    }
  }

  onUpdateItem = (updated) => {
    const { surveyList } = this.state
    let docs = [...surveyList]

    const itemIndex = docs.findIndex((x) => x._id == updated._id)
    if (itemIndex >= 0) {
      docs[itemIndex] = updated

      this.setState({ surveyList: docs })
    }

    this.closeInvidualItemAction()
  }

  addTrivvySuccessFromTemplates = (newData) => {
    this.props.setCreateModalState(false)
    this.setState({
      surveyList: [...newData, ...this.state.surveyList],
      templateModalOpen: false,
    })
  }

  handleAfterAddTrivia = (newSurvey) => {
    this.props.setCreateModalState(false)
    if (newSurvey.triviaType == 2 || newSurvey.duplicatedFromTrivvy) {
      const surveys = [...this.state.surveyList]
      surveys.unshift(newSurvey)
      this.setState({
        surveyList: [...surveys],
        uploadFileOpen: false,
      })
      if (this.props.setTrivvyOpen) {
        this.props.setTrivvyOpen(false)
      }

      if (newSurvey) {
        if (newSurvey.isMessaging) {
          this.props.history.push(
            `/home/trivia/${newSurvey.organizationId}/edit/${newSurvey._id}/share`
          )
        } else {
          this.props.history.push(
            `/home/trivia/${newSurvey.organizationId}/edit/${newSurvey._id}/edit`
          )
        }
      }
    } else {
      const surveys = [...this.state.surveyList]

      surveys.unshift(newSurvey)

      this.setState(
        {
          surveyList: [...surveys],
          uploadFileOpen: false,
          loadingCreateTrivia: true,
        },
        () => {
          if (this.props.setTrivvyOpen) {
            this.props.setTrivvyOpen(false)
          }
          this.setState({ newGeneratedSurvey: newSurvey })
        }
      )

      axios
        .post(url.generateTriviaQuestions, {
          trivia: newSurvey,
          noLoader: true,
        })
        .then(({ data }) => {
          const updatedSurvey = data.data.trivia
          const existingIndex = surveys.findIndex(
            (x) => x._id === updatedSurvey._id
          )
          if (existingIndex >= 0) {
            surveys[existingIndex] = updatedSurvey

            this.setState(
              {
                surveyList: [...surveys],
                loadingCreateTrivia: false,
              },
              () => {
                this.setState({ newGeneratedSurvey: [] })
                // toastContainer("Questions generated successfully", "success");
                toastContainer(
                  <TrivvyImmediateRewardToast
                    history={this.props.history}
                    trivvyIds={[newSurvey._id]}
                    noPlanCustomMessage={'Questions generated successfully'}
                  />,
                  'success'
                )
              }
            )
          }
        })
        .catch((error) => {
          surveys.shift()
          this.setState({
            newGeneratedSurvey: [],
            loadingCreateTrivia: false,
            surveyList: [...surveys],
          })
          let errorMsg = WEB_GENERATE_ERROR_MESSAGE
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message == 'ad_blocker'
          ) {
            errorMsg =
              'Sorry, we could not process this because there is a blocker on this website. Please save and upload as a PDF or copy and paste the text.'
          }
          toastContainer(errorMsg, 'error')

          console.log(error)
        })
    }
  }

  onTrivvyMultiGenerate = (payload, apiData) => {
    const surveys = [...payload.partsArray, ...this.state.surveyList]
    this.setState(
      {
        surveyList: [...surveys],
        uploadFileOpen: false,
        loadingCreateTrivia: true,
      },
      () => {
        if (this.props.setTrivvyOpen) {
          this.props.setTrivvyOpen(false)
        }
        this.setState({
          newGeneratedSurvey: payload.partsArray.map((x) => x.name),
        })
      }
    )

    axios
      .post(url.createOrScheduleMultipleTrivvys, apiData)
      .then(({ data }) => {
        const surveys = [...this.state.surveyList].filter((x) => x._id)

        this.setState({
          surveyList: [...data.data, ...surveys],
          newGeneratedSurvey: [],
          loadingCreateTrivia: false,
        })

        for (const item of data.data) {
          if (item.isPublished) {
            axios.put(url.shareTrivia(item._id), {
              sharedWithUsers: item.sharedWithUsers,
              privacy: item.privacy,
              shareTrivvyViaSMS: item.shareTrivvyViaSMS,
              shareTrivvyViaEmail: item.shareTrivvyViaEmail,
            })
          }
        }

        toastContainer(
          <TrivvyImmediateRewardToast
            history={this.props.history}
            trivvyIds={data.data.map((x) => x._id)}
            noPlanCustomMessage={'Questions generated successfully'}
          />,
          'success'
        )
      })
      .catch((error) => {
        surveys.shift()
        this.setState({
          newGeneratedSurvey: [],
          loadingCreateTrivia: false,
          surveyList: [...surveys],
        })
        let errorMsg = WEB_GENERATE_ERROR_MESSAGE
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message == 'ad_blocker'
        ) {
          errorMsg =
            'Sorry, we could not process this because there is a blocker on this website. Please save and upload as a PDF or copy and paste the text.'
        }
        toastContainer(errorMsg, 'error')

        console.log(error)
      })
  }

  getDataForExportResult = () => {
    const { surveyList } = this.state

    if (surveyList && surveyList.length) {
      const newList = surveyList.map((item) => ({
        name: item.name || 'NA',
        totalQuestions: item.questions ? item.questions.length : 0,
        averageScore: isTrivvyGeneratedFromCustomTemplates(item) || this.isTrivvyOfNonMcq(item)
          ? 'N/A'
          : item.totalSubmissions > 0
            ? `${Math.round(item.averageScore)}%`
            : 'N/A',
        // averageTime: `${Math.round(item.averageTime || 0)} sec`,
        source:
          item.uploadType == 0
            ? 'Webpage'
            : item.uploadType == 1
              ? 'Document'
              : 'Custom Text',
        publishStatus: item.isPublished
          ? !moment(item.trivvyEndDate).isSameOrBefore(moment(), 'day') ||
            item.trivvyEndDate == null ||
            !item.trivvyEndDate
            ? 'Published'
            : 'Ended'
          : 'NotPublished',
        createdOn: item.createdOn
          ? moment(item.createdOn).format('h:mma on MMM D, YYYY')
          : 'NA',
        totalSubmissions: item.totalSubmissions || 0,
        retakes: item.retakes,
        responseRate: (function() {
          const denominator = (item.insightsTotalCount && item.insightsTotalCount > 0)
            ? item.insightsTotalCount
            : item.otherMediumsShareCount
          if (!denominator || denominator === 0) return 'N/A'
          const numerator = item.allowAttempts > 0
            ? (item.completedUsersCount || 0)
            : (item.totalSubmissions || 0)
          const rate = Math.round((numerator / denominator) * 100)
          return rate + '%'
        })(),
      }))
      return newList
    } else {
      return []
    }
  }

  addTrivvySuccessFromTemplates = (data) => {
    if (this.props.setImportTemplateAddedTrivvys) {
      this.props.setImportTemplateAddedTrivvys(data)
      this.setState({
        uploadFileOpen: false,
      })
      if (this.props.setTrivvyOpen) {
        this.props.setTrivvyOpen(false)
      }
    }
  }

  goToRewards = () => {
    this.setState({
      uploadFileOpen: false,
    })
    if (this.props.setTrivvyOpen) {
      this.props.setTrivvyOpen(false)
    }
    this.props.handleGlobalRewardModal({
      open: true,
      trivvys: [],
    })
  }

  handleMultiplePublishUnPublish = (flag) => {
    axios
      .post(url.updateTrivvyPublishMultiple, {
        updateData: { isPublished: flag },
        trivvysToUpdate: this.state.selectedTrivvys,
      })
      .then((data) => {
        const updatedTrivias = data.data.data.trivias

        this.setState({
          selectedTrivvys: [],
        })

        for (const itm of updatedTrivias) {
          this.onUpdateItem(itm)
        }

        toastContainer('Updated succesfully', 'success')
        this.setState({ selectedTrivvys: [] })
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error occured while updating', 'error')
      })
  }

  handleMultipleDelete = () => {
    axios
      .post(url.deleteMultipleTrivias, {
        trivvysToDelete: this.state.selectedTrivvys,
      })
      .then((data) => {
        const deletedIds = this.state.selectedTrivvys

        const filtered = [...this.state.surveyList].filter(
          (x) => !deletedIds.includes(x._id)
        )

        this.setState({
          surveyList: [...filtered],
        })

        toastContainer('Deleted succesfully', 'success')

        this.setState({ selectedTrivvys: [] })
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error occured while deleting trivvys', 'error')
      })
  }

  handleMultipleEnd = () => {
    axios
      .post(url.updateTrivvyEndDateMultiple, {
        trivvysToUpdate: this.state.selectedTrivvys,
        trivvyEndDate: moment().startOf("day"),
      })
      .then(({ data }) => {
        const updatedIds = this.state.selectedTrivvys
        const updatedList = [...this.state.surveyList].map((trivvy) => {
          if (updatedIds.includes(trivvy._id)) {
            return {
              ...trivvy,
              trivvyEndDate: moment().startOf("day"),
            }
          }
          return trivvy
        })

        this.setState({
          surveyList: updatedList,
          selectedTrivvys: [],
        })

        toastContainer(
          `Successfully ended Trivvys`,
          'success'
        )
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error occurred while ending Trivvys', 'error')
      })
  }

  isTrivvyOfNonMcq = (trivvy) => {
    return (
      trivvy.questions &&
      trivvy.questions.filter((x) => x.question_type == 'MCQ').length == 0
    )
  }

  isNonKcTrivvy = (trivvy) => {
    return (
      trivvy.questions &&
      trivvy.questions.filter((question) => question.correct_options.length == 0).length > 0
    )
  }

  render() {
    const orgObject = this.props.user.profile.organizationId
    const trivvy_plan_type = orgObject && orgObject.trivvyPlanType
    const {
      uploadFileOpen,
      uploadedFile,
      trivvyCatModal,
      fileUrl,
      surveyList,
      hoveredSurvey,
      invidualItemAction,
      newGeneratedSurvey,
      loadingCreateTrivia,
      uploadUsersModal,
      purchaseResponsesModal,
      applyPurchaseModalData,
      applyPurchaseOpen,
      preSelectedTriviaIds,
      rewardDescModalId,
      selectedTrivvys,
      selectedTrivvysWarningModal,
      surveySamplesModalOpen,
    } = this.state
    const tableCols = {
      name: 2,
      status: 1,
      createdOn: 1,
      questions: 1,
      sent: 1,
      responses: 1,
      responseRate: 1,
      // avgTime: 1,
      avgScore: 1,
      action: 1,
      scheduledOn: 2,
      // linkedRewards: 1,
    }

    const tableColsMobile = {
      status: 2,
      createdOn: 2,
      questions: 1,
      sent: 1,
      responses: 1,
      responseRate: 1,
      // avgTime: 1,
      avgScore: 1,
      action: 1,
      scheduledOn: 2,
      // linkedRewards: 1,
    }

    const { showTrivvyListOnly } = this.props

    const csv_headers = [
      {
        label: 'Trivvy Name',
        key: 'name',
      },
      {
        label: 'Total questions',
        key: 'totalQuestions',
      },
      {
        label: 'Average Score',
        key: 'averageScore',
      },
      // {
      //   label: 'Average Time',
      //   key: 'averageTime',
      // },
      {
        label: 'Source',
        key: 'source',
      },
      {
        label: 'Publish Status',
        key: 'publishStatus',
      },
      {
        label: 'Created On',
        key: 'createdOn',
      },
      {
        label: 'End Date',
        key: 'trivvyEndDate',
      },
      {
        label: 'Responses',
        key: 'totalSubmissions',
      },
      {
        label: 'Retakes',
        key: 'retakes',
      },
      {
        label: 'Response Rate',
        key: 'responseRate',
      },
    ]

    const isAdmin =
      this.props.user.profile.orgAdmin ||
      this.props.user.profile.role == 'Admin'

    return (
      <div id="triviaListPage">
        {rewardDescModalId && rewardDescModalId.length > 0 ? (
          <TrivvyLinkedRewardsDetailsModal
            open={rewardDescModalId.length > 0}
            onClose={() =>
              this.setState({
                rewardDescModalId: null,
              })
            }
            trivvyId={rewardDescModalId}
          />
        ) : (
          ''
        )}
        {applyPurchaseOpen && applyPurchaseModalData ? (
          <ApplyPurchaseToTrivvy
            open={applyPurchaseOpen}
            onClose={this.closeApplyPurchaseModal}
            handleUpdateRow={this.onUpdateItem}
            trivia={applyPurchaseModalData}
          />
        ) : (
          ''
        )}
        {uploadFileOpen && (
          <CreateTriviaModalMain
            open={uploadFileOpen}
            onClose={() => {
              this.props.setCreateModalState(false)
              this.setState({ uploadFileOpen: false })
              if (this.props.setTrivvyOpen) {
                this.props.setTrivvyOpen(false)
              }
            }}
            setCreateModalState={this.props.setCreateModalState}
            onAddSuccess={this.handleAfterAddTrivia}
            user={this.props.user}
            addTrivvySuccessFromTemplates={this.addTrivvySuccessFromTemplates}
            firstTimePopupText={this.state.firstTimePopupText}
            goToRewards={this.goToRewards}
            canCreateRewards={surveyList && surveyList.length > 0}
            onTrivvyMultiGenerate={this.onTrivvyMultiGenerate}
          />
        )}

        {invidualItemAction &&
          invidualItemAction.type === 'RENAME' &&
          invidualItemAction.item ? (
          <RenamePopup
            onClose={() => {
              this.closeInvidualItemAction()
            }}
            item={this.state.invidualItemAction.item}
            open={this.state.invidualItemAction.type === 'RENAME'}
            onUpdateItem={this.onUpdateItem}
          />
        ) : (
          ''
        )}

        {/* <SurveySamplesPage
          open={surveySamplesModalOpen}
          onClose={() => this.setState({ surveySamplesModalOpen: false })}
          {...this.props}
        /> */}

        {invidualItemAction &&
          invidualItemAction.type === 'REMIND' &&
          invidualItemAction.item ? (
          <ManualRemindersModal
            open={invidualItemAction.type === 'REMIND'}
            triviaData={invidualItemAction.item}
            onClose={() => {
              this.closeInvidualItemAction()
            }}
          />
        ) : (
          ''
        )}

        {invidualItemAction &&
          invidualItemAction.type === 'DELETE' &&
          invidualItemAction.item ? (
          <DeleteTriviaPopup
            onClose={() => {
              this.closeInvidualItemAction()
            }}
            item={this.state.invidualItemAction.item}
            open={this.state.invidualItemAction.type === 'DELETE'}
            onDeleteItem={this.onDeleteItem}
          />
        ) : (
          ''
        )}

        {invidualItemAction &&
          invidualItemAction.type === 'DUPLICATE' &&
          invidualItemAction.item ? (
          <DuplicateTriviaPopup
            onClose={() => {
              this.closeInvidualItemAction()
            }}
            item={this.state.invidualItemAction.item}
            open={this.state.invidualItemAction.type === 'DUPLICATE'}
            afterDuplicateSuccess={this.handleAfterAddTrivia}
            isKc={true}
          />
        ) : (
          ''
        )}

        {!showTrivvyListOnly && (
          <div>
            {!isMobile && isAdmin && (
              <Button
                className="trivia-action-button-main mr-4 trivv-create-btn mt-2 create-trivvy-btn-itm"
                onClick={() => {
                  this.setState({
                    uploadFileOpen: true,
                  })
                }}
                // color="success"
                size="sm"
                disabled={loadingCreateTrivia}>
                + Create Knowledge Check
              </Button>
            )}

        

              {/* {!isMobile &&
              isAdmin &&
              this.props.user.profile.organizationId.trivvyPlanType !=
              '001' && (
                <Button
                  className="trivia-action-button-main add-reward-btn mr-4 mt-2"
                  style={{backgroundColor:'#fff'}}

                  onClick={() => {
                    this.setState({ rewardsModalOpen: true })
                  }}>
                  Show reward <GiOpenTreasureChest />
                </Button>
              )} */}

            {!isMobile && (
              <span>
                {' '}
                {surveyList && surveyList.length ? (
                  <CSVLink
                    data={this.getDataForExportResult()}
                    headers={csv_headers}
                    filename={`KnowledgeChecks-${moment().format('MM/DD/YYYY')}.csv`}
                    separator={','}
                    target="_blank"
                    className="mr-4 mt-2 btn trivia-action-button-main trivvy-list-export-mobile trivvy-export-table-btn">
                    {'Export to CSV'} <BsDownload size={13} />
                  </CSVLink>
                ) : (
                  ''
                )}{' '}
              </span>
            )}

            {isMobile && isAdmin && (
              <div className="mb-4 ml-3">
                <UncontrolledDropdown direction="down">
                  <DropdownToggle className="trivia-action-button-main">
                    <GiBigGear /> Knowledge Checks options
                  </DropdownToggle>
                  <DropdownMenu className="pt-2 pr-2 mt-2">
                    {/* Trivvy creation hidden on mobile; only Export remains. */}
                    <DropdownItem className="my-1">
                      <CSVLink
                        data={this.getDataForExportResult()}
                        headers={csv_headers}
                        filename={`KnowledgeChecks-${moment().format(
                          'MM/DD/YYYY'
                        )}.csv`}
                        separator={','}
                        target="_blank"
                        className="text-dark">
                        {'Export to CSV'} <BsDownload size={13} />
                      </CSVLink>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            )}

            {uploadUsersModal && (
              <UploadUsersModal
                open={uploadUsersModal}
                onClose={() => {
                  this.setState({
                    uploadUsersModal: false,
                  })
                }}
              />
            )}
          </div>
        )}

        {this.state.rewardsModalOpen && (
          <Modal isOpen={this.state.rewardsModalOpen} size="xl" toggle={() => this.setState({ rewardsModalOpen: false })}>
            <ModalHeader toggle={() => this.setState({ rewardsModalOpen: false })}>
              Rewards
            </ModalHeader>
            <ModalBody>
              <TriviaRewards {...this.props} />
            </ModalBody>
          </Modal>
        )}

        {selectedTrivvys && selectedTrivvys.length ? (
          <div style={{}} className="mt-4">
            <b
              className="mx-2 text-success cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message:
                      'Are you sure you want to publish selected knowledge checks',
                    type: 'PUBLISH',
                  },
                })
              }}>
              Publish
            </b>
            <b
              className="mx-2 text-secondary cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message:
                      'Are you sure you want to unpublish selected knowledge checks',
                    type: 'UNPUBLISH',
                  },
                })
              }}>
              Unpublish
            </b>
            <b
              className="mx-2 text-danger cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message: 'Are you sure you want to delete selected knowledge checks',
                    type: 'DELETE',
                  },
                })
              }}>
              Delete
            </b>
            <b
              className="mx-2 text-warning cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message: 'Are you sure you want to end selected Trivvys?',
                    type: 'END',
                  },
                })
              }}>
              End
            </b>

            <span>Selected knowledge checks ({selectedTrivvys.length})</span>
          </div>
        ) : (
          ''
        )}

        {selectedTrivvysWarningModal && selectedTrivvysWarningModal.open ? (
          <WarningModal
            open={selectedTrivvysWarningModal.open}
            message={selectedTrivvysWarningModal.message}
            type={selectedTrivvysWarningModal.type}
            onCancel={() => {
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
            onOk={() => {
              if (selectedTrivvysWarningModal.type === 'PUBLISH') {
                this.handleMultiplePublishUnPublish(true)
              } else if (selectedTrivvysWarningModal.type === 'UNPUBLISH') {
                this.handleMultiplePublishUnPublish(false)
              } else if (selectedTrivvysWarningModal.type === 'DELETE') {
                this.handleMultipleDelete()
              } else if (selectedTrivvysWarningModal.type === 'END') {
                this.handleMultipleEnd()
              }
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
            onClose={() => {
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
          />
        ) : (
          ''
        )}

        {surveyList.length == -1 ? (
          <div className="d-flex justify-content-center">
            <EmptyTable
              title={'No knowledge checks found'}
              subtitle={
                'You havent created any knowledge checks yet. Please create from button above.'
              }
            />
          </div>
        ) : (
          <div>
            {/* Local search bar for the Knowledge Checks tab. Hits the
                /trivia/get-trivvy-search-keyword endpoint with
                source="KNOWLEDGE_CHECK" so results are scoped to this tab and
                matched by name only. */}
            {!this.props.showTrivvyListOnly && (
              <div
                className={isMobile ? 'mb-3 px-3' : 'my-3'}
                style={isMobile ? {} : { maxWidth: '500px' }}>
                <LocalSearchBar
                  onSearch={this.handleSearch}
                  onClearSearch={this.handleClearSearch}
                  isSearching={
                    this.state.searchLoading && this.state.searchCurrentPage === 1
                  }
                  placeholder="Search Knowledge Checks..."
                  mobilePlaceholder="Search Knowledge Checks..."
                />
              </div>
            )}
            {!isMobile ? (
              <div
              // style={{
              //   minWidth: "100%",
              //   maxWidth: "100%",
              //   overflowX: "auto",
              // }}
              // className="hide-scroll"
              >
                <div
                  className="trivia_survey_list_table"
                // style={{
                //   width: "1500px",
                // }}
                >
                  <div className="my-0">
                    <LayoutRowShadow className="row-shadow-header-no-shadow px-1em mx-0">
                      <LayoutHeadingShadowLeft
                        className={'text-left'}
                        colWidth={tableCols.name}>
                        {isAdmin && (
                          <CheckBox
                            checked={
                              surveyList.length > 0 &&
                              selectedTrivvys.length === surveyList.length
                            }
                            onChange={(e) =>
                              this.handleSelectAllTrivvys(e.target.checked)
                            }
                            className="mr-2"
                          />
                        )}
                        <span>Name {this.sortComponent('name')} </span>
                      </LayoutHeadingShadowLeft>

                      <If condition={true}>
                        <LayoutHeadingShadowLeft
                          className={'trivia-table-heading-small'}
                          colWidth={tableCols.status}>
                          Status {this.sortComponent('status')}
                        </LayoutHeadingShadowLeft>
                        <LayoutHeadingShadowLeft
                          className={'trivia-table-heading-small'}
                          colWidth={tableCols.createdOn}>
                          Created {this.sortComponent('createdDate')}
                        </LayoutHeadingShadowLeft>

                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.questions}>
                          Questions {this.sortComponent('questionsCount')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={'justify-content-center '}
                          colWidth={tableCols.sent}>
                          Sent {this.sortComponent('sent')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadowLeft
                          className={'trivia-table-heading-small'}
                          colWidth={tableCols.responses}>
                          Responses{' '}
                          {this.sortComponent('submissions')}
                        </LayoutHeadingShadowLeft>
                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.responseRate}>
                          Response Rate {this.sortComponent('responseRate')}
                        </LayoutHeadingShadow>
                        {/* <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.avgTime}>
                          Average Time {this.sortComponent('averageTime')}
                        </LayoutHeadingShadow> */}
                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.avgScore}>
                          Average Score {this.sortComponent('averageScore')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.scheduledOn}>
                          Scheduled {this.sortComponent('scheduledDate')}
                        </LayoutHeadingShadow>
                        {/* {trivvy_plan_type !== '001' ? (
                          <LayoutHeadingShadow
                            className={'justify-content-center'}
                            colWidth={tableCols.linkedRewards}>
                            Rewards {this.sortComponent('linkedRewards')}
                          </LayoutHeadingShadow>
                        ) : (
                          ''
                        )} */}

                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.action}></LayoutHeadingShadow>
                      </If>
                    </LayoutRowShadow>

                    <BottomScrollListener
                      offset={100}
                      onBottom={
                        this.state.isSearchActive
                          ? this.handleSearchScrollBottom
                          : this.handleBottomScroll
                      }>
                      {(scrollRef) => (
                        <div
                          className={`trivia_survey_list_table_contents_scroll ${
                            this.getFilteredList().length == 0 ? '' : ''
                          }`}
                          ref={scrollRef}>
                          {!isMobile && this.getFilteredList().length > 0 ? (
                            this.getFilteredList().map((item, idx) => {
                              const loadingGeneratingQuestions =
                                newGeneratedSurvey &&
                                Array.isArray(newGeneratedSurvey) &&
                                newGeneratedSurvey.includes(item.name) &&
                                !item._id

                              let itm_color =
                                idx % 2 == 0 ? '#ff6233' : '#c6ffe7'

                              if (loadingGeneratingQuestions) {
                                return (
                                  <LayoutRowShadow>
                                    <LayoutData
                                      colWidth={tableCols.name}
                                      className="cursor-pointer">
                                      <div
                                        className="d-flex"
                                        data-tip={item.name}>
                                        <span
                                          className="trivia-list-item-color-chip"
                                          style={{ backgroundColor: itm_color }}
                                        />
                                        <div style={{ flex: 1 }}>
                                          <div
                                            className="survey-item-title survey-item-title-itm"
                                            onClick={() =>
                                              this.redirectToSurveyPage(item)
                                            }>
                                            <span className="survey-item-title">
                                              {item.name}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <ReactTooltip />
                                    </LayoutData>
                                    <LayoutData>
                                      <div className="text-center">
                                        {' '}
                                        <img
                                          src={Spinner}
                                          height="25px"
                                          width={'25px'}
                                        />{' '}
                                      </div>
                                    </LayoutData>
                                  </LayoutRowShadow>
                                )
                              } else {
                                return (
                                  <LayoutRowShadow
                                    key={idx}
                                    onMouseEnter={() =>
                                      this.setState({ hoveredSurvey: item._id })
                                    }
                                    onMouseLeave={() =>
                                      this.setState({ hoveredSurvey: null })
                                    }
                                    className={
                                      hoveredSurvey == item._id
                                        ? 'pink-border'
                                        : ''
                                    }>
                                    <LayoutData
                                      colWidth={tableCols.name}
                                      className="cursor-pointer">
                                      <div className="d-flex trivvy-tbl-list-row-name-col">
                                        <div>
                                          {isAdmin && (
                                            <CheckBox
                                              checked={selectedTrivvys.includes(
                                                item._id
                                              )}
                                              className="mr-2"
                                              onChange={(e) => {
                                                this.handleTrivvyRowCheckboxClick(
                                                  e.target.checked,
                                                  item._id
                                                )
                                              }}
                                            />
                                          )}
                                          {item.averageSentimentsScore &&
                                            item.averageSentimentsScore
                                              .sentiment &&
                                            item.averageSentimentsScore.sentiment
                                              .length ? (
                                            <div
                                              className=""
                                              data-tip={
                                                'Trivvy contains a sentiment analysis'
                                              }>
                                              <TiChartLine size={13} />
                                              <ReactTooltip />
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </div>

                                        <span
                                          style={{ display: 'block' }}
                                          className="survey-item-title d-block"
                                          onClick={() =>
                                            this.redirectToSurveyPage(item)
                                          }
                                          data-tip={item.name}>
                                          {item.name}

                                          {item.triviaType === 1 && (
                                            <div className="item-source-trivvy-list">
                                              Source:{' '}
                                              {item.uploadType == 0
                                                ? 'Webpage'
                                                : item.uploadType == 1
                                                  ? 'Document'
                                                  : 'Custom Text'}
                                            </div>
                                          )}
                                          <ReactTooltip />
                                        </span>
                                      </div>

                                      {hoveredSurvey == item._id && (
                                        <Button
                                          className="hover-survey-button-position trivia-action-button-main"
                                          onClick={() =>
                                            this.redirectToSurveyPage(item)
                                          }>
                                          Edit
                                        </Button>
                                      )}
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center kc-status-cell"
                                      colWidth={tableCols.status}>
                                      {moment(
                                        item.trivvyEndDate
                                      ).isSameOrBefore(moment(), 'day') ? (
                                        <Badge color="secondary">Ended</Badge>
                                      ) : item.isPublished &&
                                        item.scheduledDate &&
                                        moment(item.scheduledDate).isAfter(
                                          moment()
                                        ) ? (
                                        <Badge color="info">Scheduled</Badge>
                                      ) : item.isPublished ? (
                                        <Badge color="success">Published</Badge>
                                      ) : (
                                        <Badge color="warning">
                                          Unpublished
                                        </Badge>
                                      )}
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center kc-created-cell"
                                      colWidth={tableCols.createdOn}>
                                      {' '}
                                      <div className="survey-createddate-text">
                                        <div>
                                          {moment(item.createdOn).format(
                                            'h:mma on '
                                          )}
                                        </div>
                                        <div>
                                          {moment(item.createdOn).format(
                                            'MMM D, YYYY'
                                          )}
                                        </div>
                                      </div>
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center kc-questions-cell"
                                      colWidth={tableCols.questions}>
                                      {' '}
                                      <div
                                        data-tip="View content"
                                        onClick={() =>
                                          this.redirectToSurveyPage(item)
                                        }
                                      // className="trivia-action-button-secondary-center"
                                      >
                                        {' '}
                                        {item.questions &&
                                          item.questions.length}{' '}
                                        <ReactTooltip />
                                      </div>
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center kc-sent-cell"
                                      colWidth={tableCols.sent}>
                                      {item.insightsTotalCount && item.insightsTotalCount > 0
                                        ? item.insightsTotalCount
                                        : item.otherMediumsShareCount || 0}
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center waiting_text kc-responses-cell"
                                      colWidth={tableCols.responses}>
                                      {item.allowAttempts > 0
                                        ? item.completedUsersCount || 0
                                        : item.totalSubmissions || 0}
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center kc-response-rate-cell"
                                      colWidth={tableCols.responseRate}>
                                      {(function() {
                                        const denominator = (item.insightsTotalCount && item.insightsTotalCount > 0)
                                          ? item.insightsTotalCount
                                          : item.otherMediumsShareCount
                                        if (!denominator || denominator === 0) return 'N/A'
                                        const numerator = item.allowAttempts > 0
                                          ? (item.completedUsersCount || 0)
                                          : (item.totalSubmissions || 0)
                                        const rate = Math.round((numerator / denominator) * 100)
                                        return rate + '%'
                                      })()}
                                    </LayoutData>
                                    {/* <LayoutData
                                      className="text-center kc-avg-time-cell"
                                      colWidth={tableCols.avgTime}>
                                      {' '}
                                      {item.totalSubmissions > 0&& !this.isNonKcTrivvy(item)
                                        ? formatDuration(
                                            Math.round(item.averageTime || 0)
                                          )
                                        : 'N/A'}
                                    </LayoutData> */}
                                    <LayoutData
                                      className="text-center kc-avg-score-cell"
                                      colWidth={tableCols.avgScore}>
                                      <div
                                        data-tip="View insights"
                                        onClick={() =>
                                          this.redirectToSurveyPage(item)
                                        }
                                      // className="trivia-action-button-secondary-center"
                                      >
                                        {isTrivvyGeneratedFromCustomTemplates(
                                          item
                                        ) || this.isTrivvyOfNonMcq(item) ? (
                                          <span>N/A</span>
                                        ) : (
                                         <span>
                                            {' '}
                                            {item.totalSubmissions > 0 && !this.isNonKcTrivvy(item)
                                              ? Math.round(item.averageScore) + '%'
                                              : 'N/A'}{' '}
                                          </span>
                                        )}

                                        <ReactTooltip />
                                      </div>
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center kc-scheduled-cell"
                                      colWidth={tableCols.scheduledOn}>
                                      {' '}
                                      <div className="survey-createddate-text">
                                        {item.isPublished && item.scheduledDate ? (
                                          <span>
                                            <div>
                                              {moment(
                                                item.scheduledDate
                                              ).format(
                                                // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                                'h:mma on'
                                              )}
                                            </div>
                                            <div>
                                              {moment(
                                                item.scheduledDate
                                              ).format(
                                                // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                                'MMM D, YYYY'
                                              )}
                                            </div>
                                          </span>
                                        ) : (
                                          <div className="text-center">
                                            <LuCalendarCheck
                                              size={23}
                                              color="gray"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </LayoutData>
                                    {/* {trivvy_plan_type !== '001' && (
                                      <LayoutData
                                        className="text-center"
                                        colWidth={tableCols.linkedRewards}>
                                        {item.linkedRewards &&
                                          item.linkedRewards.length ? (
                                          <GiOpenTreasureChest
                                            className="reward-icon-color reward-icon-size"
                                            onClick={() =>
                                              this.setState({
                                                rewardDescModalId: item._id,
                                              })
                                            }
                                          />
                                        ) : (
                                          <GiOpenTreasureChest
                                            className="reward-icon-size"
                                            color="grey"
                                          />
                                        )}
                                      </LayoutData>
                                    )} */}

                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.action}>
                                      {this.renderRowOptions(item)}
                                    </LayoutData>
                                  </LayoutRowShadow>
                                )
                              }
                            })
                          ) : (
                            <LayoutRowShadow>
                              {' '}
                              <LayoutData colWidth={12}>
                                {' '}
                                <div
                                  style={{
                                    width: '100%',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    height: '40px',
                                  }}>
                                  {this.state.isSearchActive
                                    ? 'No results found'
                                    : 'No knowledge checks created'}
                                </div>{' '}
                              </LayoutData>{' '}
                            </LayoutRowShadow>
                          )}
                        </div>
                      )}
                    </BottomScrollListener>
                  </div>
                </div>
              </div>
            ) : (
              <div className="trivia_table_mobile mt-4">
                <div className="trivia-mobile-header-wrap">
                <Row className="trivia-mobile-table-header mx-0">
                  <Col xs={5} className="px-0">
                    <LayoutHeadingShadow
                      className={'justify-content-center'}
                      colWidth={12}>
                      Name {this.sortComponent('name')}{' '}
                    </LayoutHeadingShadow>
                  </Col>

                  <Col
                    xs={7}
                    className="scrollable-action-table-row trivia-mobile-header-scroll px-0"
                    onScroll={(e) => {
                      const container = e.target.closest('.trivia_table_mobile')
                      if (!container) return
                      const bodyEl = container.querySelector(
                        '.trivia_survey_list_table_contents_scroll .scrollable-action-table-row'
                      )
                      if (bodyEl && bodyEl.scrollLeft !== e.target.scrollLeft) {
                        bodyEl.scrollLeft = e.target.scrollLeft
                      }
                    }}>
                    <LayoutRowLines className="row-scroll-width-s">
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.status}>
                        Status {this.sortComponent('status')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.createdOn}>
                        Created {this.sortComponent('createdDate')}
                      </LayoutHeadingShadow>

                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.questions}>
                        Questions {this.sortComponent('questionsCount')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.sent}>
                        Sent {this.sortComponent('sent')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.responses}>
                        Responses{' '}
                        {this.sortComponent('submissions')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.responseRate}>
                        Resp. Rate {this.sortComponent('responseRate')}
                      </LayoutHeadingShadow>
                      {/* <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.avgTime}>
                        Average Time {this.sortComponent('averageTime')}
                      </LayoutHeadingShadow> */}
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.avgScore}>
                        Average Score {this.sortComponent('averageScore')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.scheduledOn}>
                        Scheduled {this.sortComponent('scheduledDate')}
                      </LayoutHeadingShadow>

                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={
                          tableColsMobile.action
                        }></LayoutHeadingShadow>
                    </LayoutRowLines>
                  </Col>
                </Row>
                </div>

                <BottomScrollListener
                  onBottom={
                    this.state.isSearchActive
                      ? this.handleSearchScrollBottom
                      : this.handleBottomScroll
                  }>

                  {(scrollRef) => (
                    <div
                      className="trivia_survey_list_table_contents_scroll"
                      ref={scrollRef}>
                      <Row className="mx-0">
                        <Col xs={5} className="px-0">
                          {this.getFilteredList().length == 0 ? (
                            <Row
                              className={
                                'planning-row-mobile-height layout-row-shadow mx-0'
                              }>
                              <LayoutData colWidth={12}>
                                {this.state.isSearchActive
                                  ? 'No results found'
                                  : 'No knowledge checks created'}
                              </LayoutData>
                            </Row>
                          ) : (
                            ''
                          )}

                          {this.getFilteredList().map((item, idx) => {
                            return (
                              <LayoutRowLines
                                key={idx}
                                className={
                                  'planning-row-mobile-height mx-0 px-0'
                                }>
                                <LayoutDataLines colWidth={12} noFlex>
                                  <div
                                    onClick={() =>
                                      this.redirectToSurveyPage(item)
                                    }
                                    className="cursor-pointer">
                                    <div
                                      className="survey-item-title-itm"
                                      data-tip={item.name}>
                                      <span className="survey-item-title">
                                        {item.name}
                                      </span>
                                      {item.triviaType === 1 && (
                                        <div className="item-source-trivvy-list">
                                          Source:{' '}
                                          {item.uploadType == 0
                                            ? 'Webpage'
                                            : item.uploadType == 1
                                              ? 'Document'
                                              : 'Custom Text'}
                                        </div>
                                      )}
                                    </div>
                                    <ReactTooltip />
                                  </div>
                                  <ReactTooltip />
                                </LayoutDataLines>
                              </LayoutRowLines>
                            )
                          })}
                        </Col>

                        <Col
                          xs={7}
                          className="scrollable-action-table-row px-0"
                          onScroll={(e) => {
                            const container = e.target.closest('.trivia_table_mobile')
                            if (!container) return
                            const headerEl = container.querySelector(
                              '.trivia-mobile-table-header .scrollable-action-table-row'
                            )
                            if (headerEl && headerEl.scrollLeft !== e.target.scrollLeft) {
                              headerEl.scrollLeft = e.target.scrollLeft
                            }
                          }}>
                          {this.getFilteredList().map((item, idx) => {
                            return (
                              <LayoutRowLines
                                key={idx}
                                className={`pl-tasks-row ${
                                  isMobile ? 'row-scroll-width-s' : ''
                                }`}>
                                <LayoutDataLines
                                  className="text-center font-13px"
                                  colWidth={tableColsMobile.status}>
                                  {moment(item.trivvyEndDate).isSameOrBefore(
                                    moment(),
                                    'day'
                                  ) ? (
                                    <Badge color="secondary">Ended</Badge>
                                  ) : item.isPublished &&
                                    item.scheduledDate &&
                                    moment(item.scheduledDate).isAfter(
                                      moment()
                                    ) ? (
                                    <Badge color="info">Scheduled</Badge>
                                  ) : item.isPublished ? (
                                    <Badge color="success">Published</Badge>
                                  ) : (
                                    <Badge color="warning">Unpublished</Badge>
                                  )}
                                </LayoutDataLines>

                                <LayoutDataLines
                                  className="text-center font-13px"
                                  colWidth={tableColsMobile.createdOn}>
                                  {' '}
                                  <div className="survey-createddate-text text-info">
                                    {moment(item.createdOn).format(
                                      'h:mma on MMM D, YYYY'
                                    )}
                                  </div>
                                </LayoutDataLines>
                                <LayoutDataLines
                                  colWidth={tableColsMobile.questions}
                                  className="text-center font-13px">
                                  {item.questions && item.questions.length}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  className="text-center font-13px"
                                  colWidth={tableColsMobile.sent}>
                                  {item.insightsTotalCount && item.insightsTotalCount > 0
                                    ? item.insightsTotalCount
                                    : item.otherMediumsShareCount || 0}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  className="text-center py-1 font-13px waiting_text"
                                  colWidth={tableColsMobile.responses}>
                                  {item.allowAttempts > 0
                                    ? item.completedUsersCount || 0
                                    : item.totalSubmissions || 0}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  className="text-center py-1 font-13px"
                                  colWidth={tableColsMobile.responseRate}>
                                  {(function() {
                                    const denominator = (item.insightsTotalCount && item.insightsTotalCount > 0)
                                      ? item.insightsTotalCount
                                      : item.otherMediumsShareCount
                                    if (!denominator || denominator === 0) return 'N/A'
                                    const numerator = item.allowAttempts > 0
                                      ? (item.completedUsersCount || 0)
                                      : (item.totalSubmissions || 0)
                                    const rate = Math.round((numerator / denominator) * 100)
                                    return rate + '%'
                                  })()}
                                </LayoutDataLines>
                                {/* <LayoutDataLines
                                  colWidth={tableColsMobile.avgTime}
                                  className="text-center text-danger font-13px">
                                  {item.totalSubmissions > 0
                                    ? formatDuration(
                                      Math.round(item.averageTime || 0)
                                    )
                                    : 'N/A'}
                                </LayoutDataLines> */}
                                <LayoutDataLines
                                  colWidth={tableColsMobile.avgScore}
                                  className="text-center text-success font-13px">
                                  {isTrivvyGeneratedFromCustomTemplates(item) ||
                                    this.isTrivvyOfNonMcq(item) ? (
                                    <span>N/A</span>
                                  ) : (
                                    <span>
                                      {' '}
                                      {item.totalSubmissions > 0
                                        ? Math.round(item.averageScore) + '%'
                                        : 'N/A'}
                                    </span>
                                  )}
                                </LayoutDataLines>

                                <LayoutDataLines
                                  colWidth={tableColsMobile.scheduledOn}
                                  className="text-center text-success font-13px">
                                  <div className="survey-createddate-text">
                                    {item.isPublished && item.scheduledDate ? (
                                      <span>
                                        <div>
                                          {moment(item.scheduledDate).format(
                                            // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                            'h:mma on'
                                          )}
                                        </div>
                                        <div>
                                          {moment(item.scheduledDate).format(
                                            // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                            'MMM D, YYYY'
                                          )}
                                        </div>
                                        {/* <div>
                                          {moment(item.scheduledDate).format(
                                            // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                            "h:mma on MMM D, YYYY"
                                          )}
                                        </div> */}
                                      </span>
                                    ) : (
                                      <div className="text-center">
                                        <LuCalendarCheck
                                          size={23}
                                          color="gray"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </LayoutDataLines>

                                {/* {trivvy_plan_type !== '001' && (
                                  <LayoutDataLines
                                    className="text-center font-13px"
                                    colWidth={tableColsMobile.linkedRewards}>
                                    {item.linkedRewards &&
                                      item.linkedRewards.length ? (
                                      <GiOpenTreasureChest
                                        className="reward-icon-color reward-icon-size"
                                        onClick={() =>
                                          this.setState({
                                            rewardDescModalId: item._id,
                                          })
                                        }
                                      />
                                    ) : (
                                      <GiOpenTreasureChest
                                        className="reward-icon-size"
                                        color="grey"
                                      />
                                    )}
                                  </LayoutDataLines>
                                )} */}

                                <LayoutDataLines
                                  colWidth={tableColsMobile.action}
                                  className="text-center">
                                  {this.renderRowOptions(item)}
                                </LayoutDataLines>
                              </LayoutRowLines>
                            )
                          })}
                        </Col>
                      </Row>
                    </div>
                  )}
                </BottomScrollListener>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.triviaList
        ? state.sortFilterParams.triviaList.sort &&
          state.sortFilterParams.triviaList.sort.hasOwnProperty('sortBy')
          ? state.sortFilterParams.triviaList.sort
          : { sortBy: '', sortOrder: '' }
        : { sortBy: '', sortOrder: '' },

    importTemplateAddedTrivvys: state.trivia.importTemplateAddedTrivvys,
    showCreatePopup: state.trivia.showCreatePopup,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    updateSortParams: (data) => dispatch(actionCreators.updateTriviaSort(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),

    handleGlobalRewardModal: (data) =>
      dispatch(actionCreators.handleGlobalRewardModal(data)),
    setCreateModalState: (data) =>
      dispatch(actionCreators.setCreateModalState(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaKCSList, axios))
